import { Modal } from '@chikara/ui';
import { t } from '@/i18n';

interface RejectCardModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => Promise<void>;
    isRejecting?: boolean;
}

export const RejectCardModal = ({
    isOpen,
    onClose,
    onConfirm,
    isRejecting,
}: RejectCardModalProps) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={t('dashboard.card.detail.modals.rejectCard.title')}
            actionLabel={t('dashboard.card.detail.modals.rejectCard.confirm')}
            onAction={onConfirm}
            isActionDisabled={isRejecting}
            isActionLoading={isRejecting}
            secondaryActionLabel={t('dashboard.card.detail.modals.rejectCard.cancel')}
            onSecondaryAction={onClose}
        >
            <p>{t('dashboard.card.detail.modals.rejectCard.description')}</p>
        </Modal>
    );
};
